// @flow
import React, { Fragment } from 'react';
import { Badge } from 'Components/frameworks/badge/Badge';
import { getExclusiveCollectionProductBadgeIcon } from 'Components/utils/product/product.utils';
import { Title } from 'Components/frameworks/title/Title';
import { COLORS } from 'Components/utils/color/colors';
import { Icon } from 'Components/frameworks/icon/Icon.jsx';
import { ICONS } from 'Components/utils/icon/icons';
import classnames from 'classnames';

type Props = {
  product: Resort,
  className?: string,
  isExclusiveCollection?: boolean,
};

const ResortBannerBadge = ({ product, isExclusiveCollection }) => {
  // $FlowFixMe
  const icon = product.badgeIcon ? ICONS[product.badgeIcon] : '';
  return (
    <Fragment>
      {!isExclusiveCollection || (icon === ICONS.TRIDENT45 || icon === ICONS.TRIDENT6) ? (
        <Badge
          {...getExclusiveCollectionProductBadgeIcon(product)}
          className="flex-shrink-0 rounded-tiny"
        />
      ) : null}
      {isExclusiveCollection || icon === ICONS.TRIDENT45 ? (
        <div
          className="bg-deepBlue p-3 rtl:ml-2 inset-border-after--small relative flex items-center justify-center"
          style={{ height: '50px', width: '96px' }}
        >
          <Icon
            name={ICONS.EXCLUSIVE_COLLECTION}
            width="calc(72rem / 16)"
            color={COLORS.WHITE}
            className="absolute left-1/2 top-1/2 -translate-50"
            isNotSquare
          />
        </div>
      ) : null}
    </Fragment>
  );
};

export const ResortBanner = ({ product, className = '', isExclusiveCollection }: Props) => {
  return (
    <div className={classnames(className, 'items-center hidden lg:flex')}>
      <ResortBannerBadge product={product} isExclusiveCollection={isExclusiveCollection} />
      <div className="flex-auto mx-3">
        <Title
          className="font-brand font-normal leading-tight text-xl"
          color={COLORS.GRAY_DARKER}
          hLevel={2}
          theme="none"
        >
          {product.name}
        </Title>
        <Title
          className="font-sans font-bold leading-tight text-md uppercase"
          color={COLORS.GRAY_DARKER}
          hLevel={3}
          theme="none"
        >
          {product.destination.country}
        </Title>
      </div>
    </div>
  );
};
